import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

export const customRelativeTime = (date: moment.Moment) => {
  const today = moment().utc().startOf('day')
  const tomorrow = moment().utc().startOf('day').add(1, 'day')
  const yesterday = moment().utc().startOf('day').subtract(1, 'day')

  if (date.isSame(today, 'd')) {
    return i18n.t('one_on_ones.meeting.date.today')
  } else if (date.isSame(tomorrow, 'd')) {
    return i18n.t('one_on_ones.meeting.date.tomorrow')
  } else if (date.isSame(yesterday, 'd')) {
    return i18n.t('one_on_ones.meeting.date.yesterday')
  } else {
    return date.fromNow()
  }
}
